/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Picture from 'components/Picture/Picture';
import Title from '../ResponsiveTitle/ResponsiveTitle';
import { useImageHeight } from '../effects';
import useAnimation from './animations';
import './LargeIntro.scss';

/**
 * This is the LargeIntro component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function LargeIntro({ heading, author, image, photographer }) {
  const imageRef = useImageHeight(200);
  const [ref] = useAnimation();

  function renderAuthor() {
    if (!author) return null;

    return <div className="author">{author}</div>;
  }

  function renderPhotographer() {
    if (!photographer) return null;

    return <div className="photo">{photographer}</div>;
  }

  return (
    <header ref={ref} className="header large-intro">
      <div ref={imageRef}>
        {renderAuthor()}
        <div className="image">
          <div>
            <Picture {...image} />
          </div>
        </div>
        {renderPhotographer()}
        <Title>{heading}</Title>
      </div>
    </header>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
LargeIntro.propTypes = {
  enhanced: PropTypes.bool,
  image: PropTypes.object,
  heading: PropTypes.string,
  excerpt: PropTypes.string,
  author: PropTypes.string,
  photographer: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
LargeIntro.defaultProps = {
  enhanced: false,
  image: {},
  heading: '',
  excerpt: '',
};

export default LargeIntro;
